var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"well mb-4"},[(_vm.title)?_c('p',{staticClass:"title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"subtitle",class:{ 'font-italic': _vm.italicSubtitle }},[_vm._t("subtitle",function(){return [_vm._v(_vm._s(_vm.subtitle))]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }